<template>
    <div class="home">
        <b-container fluid>
            <h1 class="mb-3">Select Product Category</h1>
            <p style="font-size: 18px;"><b>
              Click on a category to view available products.
            </b></p>
<!--            <b-row>-->
<!--              <b-col>-->
<!--                <b-alert variant="warning" dismissible show>-->
<!--                  Record Change products may not be ordered with any non-Record Change product.-->
<!--                  If you need to order a Record Change product and a product in any other category you must make two separate orders.-->
<!--                </b-alert>-->
<!--              </b-col>-->
<!--            </b-row>-->
            <b-row class="mt-4" v-if="!orderTypeService.isTypeSet() || orderTypeService.isNonAmendType()">
                <b-col>
                    <router-link class="no-decoration" :to="{name: 'birth-select'}">
                        <b-card
                                class="order-card"
                                border-variant="primary"
                                header="Birth"
                                header-class="text-left"
                                header-bg-variant="primary"
                                header-text-variant="white"
                                align="left"
                        >
                            <b-card-text>
                                <p>
                                  Birth certificates and other documents issued from birth records. Some records are confidential and have restrictions on eligibility.
                                </p>
                            </b-card-text>
                        </b-card>
                    </router-link>
                </b-col>
            </b-row>
<!--            <b-row no-gutters v-if="!orderTypeService.isTypeSet() || orderTypeService.isNonAmendType()">-->
<!--                <b-col>-->
<!--                    <router-link class="no-decoration" :to="{name: 'death-select'}">-->
<!--                        <b-card-->
<!--                                class="order-card"-->
<!--                                border-variant="primary"-->
<!--                                header="Death"-->
<!--                                header-class="text-left"-->
<!--                                header-bg-variant="primary"-->
<!--                                header-text-variant="white"-->
<!--                                align="left"-->
<!--                        >-->
<!--                            <b-card-text>-->
<!--                              <p>-->
<!--                                Death certificates and other documents issued from death records.-->
<!--                              </p>-->
<!--                            </b-card-text>-->
<!--                        </b-card>-->
<!--                    </router-link>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--              <b-row v-if="!orderTypeService.isTypeSet() || orderTypeService.isNonAmendType()">-->
<!--                <b-col>-->
<!--                    <router-link class="no-decoration" :to="{name: 'stillbirth-select'}">-->
<!--                        <b-card-->
<!--                                class="order-card"-->
<!--                                border-variant="primary"-->
<!--                                header="Stillbirth"-->
<!--                                header-class="text-left"-->
<!--                                header-bg-variant="primary"-->
<!--                                header-text-variant="white"-->
<!--                                align="left"-->
<!--                        >-->
<!--                            <b-card-text>-->
<!--                              <p>-->
<!--                                Certificates and other documents issued from fetal death records.-->
<!--                              </p>-->
<!--                            </b-card-text>-->
<!--                        </b-card>-->
<!--                    </router-link>-->
<!--                </b-col>-->
<!--            </b-row>-->
            <b-row v-if="!orderTypeService.isTypeSet() || orderTypeService.isNonAmendType()">
                <b-col>
                    <router-link class="no-decoration" :to="{name: 'data-select'}">
                        <b-card
                                class="order-card"
                                border-variant="primary"
                                header="Data"
                                header-class="text-left"
                                header-bg-variant="primary"
                                header-text-variant="white"
                                align="left"
                        >
                            <b-card-text>
                                <p>
                                  Reports containing public data from Minnesota birth and death records.
                                </p>
                            </b-card-text>
                        </b-card>
                    </router-link>
                </b-col>
            </b-row>
<!--            <b-row v-if="!orderTypeService.isTypeSet() || orderTypeService.isAmendType()">-->
<!--              <b-col>-->
<!--                <router-link class="no-decoration" :to="{name: 'change-select'}">-->
<!--                  <b-card-->
<!--                      class="order-card"-->
<!--                      border-variant="primary"-->
<!--                      header="Record Changes"-->
<!--                      header-class="text-left"-->
<!--                      header-bg-variant="primary"-->
<!--                      header-text-variant="white"-->
<!--                      align="left"-->
<!--                  >-->
<!--                    <b-card-text>-->
<!--                      <p>-->
<!--                        Amendments to birth and death records, replacements to birth records, and corrections to fetal death records.-->
<!--                      </p>-->
<!--                    </b-card-text>-->
<!--                  </b-card>-->
<!--                </router-link>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row v-if="!orderTypeService.isTypeSet() || orderTypeService.isNonAmendType()">-->
<!--              <b-col>-->
<!--                <router-link class="no-decoration" :to="{name: 'parentage-select'}">-->
<!--                  <b-card-->
<!--                      class="order-card"-->
<!--                      border-variant="primary"-->
<!--                      header="Parentage"-->
<!--                      header-class="text-left"-->
<!--                      header-bg-variant="primary"-->
<!--                      header-text-variant="white"-->
<!--                      align="left"-->
<!--                  >-->
<!--                    <b-card-text>-->
<!--                      <p>-->
<!--                        Certified copies of parentage documents filed with the Minnesota Department of Health.-->
<!--                      </p>-->
<!--                    </b-card-text>-->
<!--                  </b-card>-->
<!--                </router-link>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--            <b-row v-if="!orderTypeService.isTypeSet() || orderTypeService.isNonAmendType()">-->
<!--                <b-col>-->
<!--                    <router-link class="no-decoration" :to="{name: 'mfar-select'}">-->
<!--                        <b-card-->
<!--                                class="order-card"-->
<!--                                header="Minnesota Fathers' Adoption Registry"-->
<!--                                header-class="text-left"-->
<!--                                border-variant="primary"-->
<!--                                header-bg-variant="primary"-->
<!--                                header-text-variant="white"-->
<!--                                align="left"-->
<!--                        >-->
<!--                            <b-card-text>-->
<!--                                <p>-->
<!--                                  Search requests and certified search results of the Minnesota Fathers Adoption Registry.-->
<!--                                </p>-->
<!--                            </b-card-text>-->
<!--                        </b-card>-->
<!--                    </router-link>-->
<!--                </b-col>-->
<!--            </b-row>-->
        </b-container>
    </div>
</template>

<script>

import {orderTypeService} from "@/mixins/orderTypeService";

export default {
  data: () => ({
  }),
  
  computed: {
    orderTypeService() {
      return orderTypeService
    }
  },

  mounted() {
  },

  methods: {
  },
  created() {
    document.title = "Select Product - Online Storefront"
  },

}
</script>

<style>
</style>
